import initMrNotes from '~/mr_notes/init_mr_notes';

export default (createRapidDiffsApp) => initMrNotes(createRapidDiffsApp);
